class ResultViewComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`

    <div class="row mt-3 d-none" style="max-width: 900px;">
      <div id="api-error-div" class="col-12">
        <div class="card" style="max-width: 900px;">
          <div class="card-header">
            <h3>There was a problem designing this beam.</h3>
          </div>
          <div class="card-body">
            <h4><a href='mailto:jeff@webstructural.com'>Please report this problem.</a></h4>
            <div id='api-error-panel'></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- result summary -->

    <div class="row mt-3" style="max-width: 900px;">
      <div id="results-view-div" class="col-12 d-none">
        <div class="card" style="max-width: 900px;">
          <div class="card-header text-start">
            Result View
              <select id='result-group-selector' onchange='onResultGroupChange()'>
                <option value='load_case_results' selected>Load Case</option>
                <option value='combination_results'>Load Combination</option>
                <option value='service_case_results'>Service Case</option>
              </select>
              <span id="numerical-results-selector-holder"></span>
          </div>
          <div class="card-body">
            <div id="results-canvas-pane"></div>
            <div id='extreme-results-table'></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Reactions -->
    <div class="row mt-3" style="max-width: 900px;">
      <div id="beam-reactions-div" class="col-12 d-none">
        <div class="card" style="max-width: 900px;">
          <div id="reactions-heading" class="card-header text-start">
            Load Case Reactions
          </div>
          <div class="card-body">
            <div id="beam-reactions-table"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Plots -->

    <div class="page-break-before"></div>

    <div class="row mt-3" style="max-width: 900px;">
      <div id="plots-div" class="col-12 d-none">
        <div class="card" style="max-width: 900px;">
        <div class="card-header text-start">
          Plots 
          <select id='plot-result-group-selector' onchange='onPlotResultGroupChange()'>
            <option value='load_case_results'>Load Cases</option>
            <option value='combination_results' selected>Load Combinations</option>
            <option value='service_case_results'>Service Cases</option>
          </select>
        </div>
        <div class="card-body">
          <div id='plot-panel-area'></div>
        </div>
        </div>
      </div>
    </div>


    <!-- Numerical Results -->
    
    <div class="row mt-3" style="max-width: 900px;">
      <div id="numerical-results-div" class="col-12 d-none">
        <div class="card card-default" style="max-width: 900px;">
          <div class="card-header text-start">
            Numerical Results (<span id="numerical-results-equation-title"></span>)
          </div>
          <div class="card-body">
            <div id='beam-numerical-results-table'></div>
          </div>
        </div>
      </div>
    </div>
    `
  }
}

customElements.define('result-view', ResultViewComponent);